import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq, motion } = theme.custom;
    return {
        container: { maxHeight: 'calc(100vh - 330px)', minHeight: 240 },
        row: { cursor: 'pointer' },
        orderCell: { minWidth: 240 },
        dateCell: { whiteSpace: 'nowrap' },
        orderNumber: { fontWeight: 600, color: color.text.primary, whiteSpace: 'nowrap' },
        orderLink: {
            fontWeight: 600,
            color: color.text.primary,
            whiteSpace: 'nowrap',
            textDecoration: 'none',
            borderRadius: 4,
            '&:hover': { color: color.primary.main, textDecoration: 'underline' },
        },
        orderExternal: { fontSize: 12, color: color.text.secondary, marginTop: 2, fontFamily: theme.custom.font.mono, whiteSpace: 'nowrap', [mq.sm]: { whiteSpace: 'normal', overflowWrap: 'anywhere' } },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        muted: { color: color.text.secondary },
        openButton: { color: color.text.secondary, '&:hover': { color: color.primary.main } },
        // phone layout: one card per order
        cards: { display: 'flex', flexDirection: 'column', gap: 10, padding: 12 },
        card: {
            display: 'block',
            width: '100%',
            textAlign: 'left',
            padding: 14,
            borderRadius: radius.md,
            border: `1px solid ${color.border}`,
            backgroundColor: color.surfaceRaised,
            fontFamily: 'inherit',
            transitionProperty: 'background-color, border-color',
            transitionDuration: motion.fast,
            '&:hover': { borderColor: color.primary.main },
        },
        cardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 10 },
        cardGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: '8px 12px',
            fontSize: 13,
            [mq.xs]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
        },
        cardLabel: { fontSize: 11, color: color.text.secondary, display: 'block', marginBottom: 2 },
        cardValue: { fontVariantNumeric: 'tabular-nums', color: color.text.primary },
        cardChips: { display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 10 },
    };
});
